export const disponibilite = {
  policies: ["Nom de voie", "Nombre de places"],
  onStreet: ["Régulation", "Places calculées"],
};

export const perPages = [10, 20, 30, 40, 50];
